// extracted by mini-css-extract-plugin
module.exports = {"title_wrap":"EventTitle_title_wrap__IeUS5","title_left":"EventTitle_title_left__ksLuM","org_wrap":"EventTitle_org_wrap__rrL6_","title_right":"EventTitle_title_right__N_iad"};